import React from 'react';
import { 
  FaBreadSlice, FaLeaf, FaMortarPestle, FaCheese, FaCandyCane, 
  FaWineBottle, FaCarrot, FaPepperHot
} from 'react-icons/fa';
import './DietaryConfig.scss';

interface DietaryOnlyProps {
  gluten: boolean;
  setGluten: (val: boolean) => void;
  vegano: boolean;
  setVegano: (val: boolean) => void;
  sodio: boolean;
  setSodio: (val: boolean) => void;
  lactosa: boolean;
  setLactosa: (val: boolean) => void;
  azucar: boolean;
  setAzucar: (val: boolean) => void;
  alcohol: boolean;
  setAlcohol: (val: boolean) => void;
  vegetariano: boolean;
  setVegetariano: (val: boolean) => void;
  picante: boolean;
  setPicante: (val: boolean) => void;
}

const DietaryConfig: React.FC<DietaryOnlyProps> = ({
  gluten, setGluten, vegano, setVegano, sodio, setSodio, lactosa, setLactosa,
  azucar, setAzucar, alcohol, setAlcohol, vegetariano, setVegetariano,
  picante, setPicante
}) => {
  const dietaryTags = [
    { key: 'gluten', label: 'Contiene Gluten', icon: FaBreadSlice, value: gluten, setter: setGluten, color: '#f59e0b' },
    { key: 'vegano', label: 'Vegano', icon: FaLeaf, value: vegano, setter: setVegano, color: '#10b981' },
    { key: 'vegetariano', label: 'Vegetariano', icon: FaCarrot, value: vegetariano, setter: setVegetariano, color: '#84cc16' },
    { key: 'lactosa', label: 'Contiene Lactosa', icon: FaCheese, value: lactosa, setter: setLactosa, color: '#f97316' },
    { key: 'azucar', label: 'Alto en Azúcar', icon: FaCandyCane, value: azucar, setter: setAzucar, color: '#ec4899' },
    { key: 'alcohol', label: 'Contiene Alcohol', icon: FaWineBottle, value: alcohol, setter: setAlcohol, color: '#8b5cf6' },
    { key: 'sodio', label: 'Alto en Sodio', icon: FaMortarPestle, value: sodio, setter: setSodio, color: '#ef4444' },
    { key: 'picante', label: 'Picante', icon: FaPepperHot, value: picante, setter: setPicante, color: '#dc2626' }
  ];

  return (
    <div className="dietary-ingredients-config">
      <div className="config-section">
        <div className="section-header">
          <h6 className="section-title">Información Nutricional y Restricciones</h6>
        </div>
        
        <div className="dietary-tags-grid">
          {dietaryTags.map((tag) => (
            <div
              key={tag.key}
              className={`dietary-tag ${tag.value ? 'active' : ''}`}
              onClick={() => tag.setter(!tag.value)}
              style={{ '--tag-color': tag.color } as React.CSSProperties}
            >
              <tag.icon className="tag-icon" />
              <span className="tag-label">{tag.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DietaryConfig;
